export const SCHEMA_VERSION = 2;
export const DEFAULT_CATEGORY_ID = 'cat-uncategorized';
export const DEFAULT_LADDER_GROUP_COLOR = '#FB923C';

export enum CardStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  BLOCKED = 'BLOCKED',
  DONE = 'DONE',
  CLOSED = 'CLOSED'
}

export enum QuickFilter {
  ALL = 'ALL',
  ACTIVE = 'ACTIVE',
  COMPLETED = 'COMPLETED'
}
